// https://github.com/jurassix/joi-validation-strategy/blob/master/src/joiValidationStrategy.js

import Joi from '@hapi/joi';
import he from 'he';
import invariant from 'invariant';
import { flowRight, get, groupBy, isEmpty, set } from 'lodash';

interface IObjectCtor extends ObjectConstructor {
    assign(target: any, ...sources: any[]): any;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
declare let Object: IObjectCtor;

function collectErrors(error: any) {
    if (error !== null) {
        return groupBy(error.details, 'path');
    }
    return {};
}

function decodeMessages(error: any) {
    if (error !== null) {
        error.details = error.details.map((e: any) => Object.assign({}, e, { message: he.decode(e.message) }));
        return error;
    }
    return {};
}

function hydrate(flat: any) {
    return Object.keys(flat)
        .sort()
        .reduce((obj, path) => set(obj, path, flat[path]), {});
}

function pickMessages(error: any) {
    if (error !== null) {
        return Object.keys(error).reduce((obj: any, key: any) => {
            obj[key] = error[key].map((item: any) => item.message);
            return obj;
        }, {});
    }
    return {};
}

// eslint-disable-next-line import/no-default-export
export default () => {
    return {
        validate(data = {}, joiSchema = {}, options: any = {}, moreJoiOptions = {}, callback: any) {
            invariant(
                typeof callback === 'function',
                'joi-validation-strategy is asynchronous, a callback is expected: validate(data, schema, options, callback)',
            );

            const { key } = options;
            const prevErrors = options.preErrors || {};

            const validationOptions = Object.assign({}, moreJoiOptions, {
                abortEarly: false,
                allowUnknown: true,
            });

            Joi.validate(data, joiSchema, validationOptions, (error) => {
                const errors = flowRight(hydrate, pickMessages, collectErrors, decodeMessages)(error);
                if (key === undefined || key === null || isEmpty(errors)) {
                    return callback(errors);
                }
                return callback(set(prevErrors, key, get(errors, key)));
            });
        },
    };
};
